import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import ActivityLabel from 'components/ActivityLabel';
import DeviceIconComponent from 'components/DeviceIconComponent';
import DeviceName from 'components/EnergyReportComponents/DeviceName';

import type { PublicDatabaseDevice } from 'redux-store/slices/devices/types';

interface DeviceActivityStatusProps {
  device: PublicDatabaseDevice & {
    success?: boolean;
  };
  onClick: () => void;
}

const DeviceActivityStatus: FC<DeviceActivityStatusProps> = ({
  device,
  onClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <ListItem
      sx={{
        borderBottom: `1px solid ${theme.vars.palette.grey[100]}`,
      }}
    >
      <ListItemIcon>
        <DeviceIconComponent
          typ={device.type}
          subtype={device.subtype}
          outlined
        />
      </ListItemIcon>
      <ListItemText
        primary={<DeviceName serial={device.serial} />}
        secondary={t('common:serial_number_with_value', {
          value: device.serial,
        })}
      />
      <Box gap={0.5} display="flex" alignItems="center">
        {device.success === false ? <ActivityLabel status="Failed" /> : null}
        {device.activities?.includes('pending') ? (
          <ActivityLabel status="Pending" />
        ) : null}
        {device.activities?.includes('protected') ? (
          <ActivityLabel status="Protected" onClick={onClick} />
        ) : null}
      </Box>
    </ListItem>
  );
};

export default DeviceActivityStatus;
